import { z } from "zod";

import { AssetSchema, AssetTypeSchema } from "../../../schemas/organization";

export const GetAssetsRequestPathParamSchema = z.object({
  themeId: z.string(),
});

export type GetAssetsRequestPathParamType = z.infer<
  typeof GetAssetsRequestPathParamSchema
>;

export const GetAssetsRequestQueryParamSchema = z.object({
  assetType: z.enum(AssetTypeSchema),
});

export type GetAssetsRequestQueryParamType = z.infer<
  typeof GetAssetsRequestQueryParamSchema
>;

export const GetAssetsResponseBodySchema = z.object({
  assets: AssetSchema.array(),
});

export type GetAssetsResponseBodyType = z.infer<
  typeof GetAssetsResponseBodySchema
>;
